<template>
  <div class="component-box page-aside">
    <div style="height: 100%" v-if="floor.id != 0">
      <el-scrollbar style="height: 100%; width: 100%">
        <MAsideState v-if="floor.id == 200"></MAsideState>
        <MAsideTab v-if="floor.id == 201"></MAsideTab>
        <MAsideArticle v-if="floor.id == 202" :floor="floor"></MAsideArticle>
        <MAsideVideo v-if="floor.id == 203" :floor="floor"></MAsideVideo>
        <MAsideResource v-if="floor.id == 204" :floor="floor"></MAsideResource>
        <MAsideAlbum v-if="floor.id == 205" :floor="floor"></MAsideAlbum>
        <MAsideNav v-if="floor.id == 206" :floor="floor"></MAsideNav>
        <MAsideSwiper v-if="floor.id == 207" :floor="floor"></MAsideSwiper>
        <MAsideEditor v-if="floor.id == 208" :floor="floor"></MAsideEditor>
        <MAsideDiscount v-if="floor.id == 209" :floor="floor"></MAsideDiscount>
      </el-scrollbar>
    </div>
    <div v-else class="no-floor">
      <img src="../../assets/images/pc-decoration/no-floor-img.png" alt="" />
      <p>请先选择楼层，即可编辑哦~</p>
    </div>
  </div>
</template>

<script>
import MAsideState from "./aside/m-aside-state.vue";
import MAsideTab from "./aside/m-aside-tab.vue";
import MAsideSwiper from "./aside/m-aside-swiper.vue";
import MAsideArticle from "./aside/m-aside-article.vue";
import MAsideVideo from "./aside/m-aside-video.vue";
import MAsideResource from "./aside/m-aside-resource.vue";
import MAsideAlbum from "./aside/m-aside-album.vue";
import MAsideNav from "./aside/m-aside-nav.vue";
import MAsideEditor from "./aside/m-aside-editor.vue";
import MAsideDiscount from "./aside/m-aside-discount.vue";
export default {
  name: "ShopCenterAdminWebMAside",
  components: {
    MAsideState,
    MAsideTab,
    MAsideSwiper,
    MAsideArticle,
    MAsideVideo,
    MAsideResource,
    MAsideAlbum,
    MAsideNav,
    MAsideEditor,
    MAsideDiscount,
  },
  props: {
    floor: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.page-aside {
  position: fixed;
  top: 47px;
  right: 0;
  bottom: 71px;
  width: 325px;
  padding: 35px 30px;
  background: #ffffff;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden !important;
    padding-bottom: 20px;
  }
  // ::v-deep .el-scrollbar__thumb {
  //   // margin-right: -10px;
  //   // transform: translate(-10px, 0);
  //   position: relative;
  //   right: -10px;
  // }

  .no-floor {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    img {
      width: 158px;
      height: 95px;
    }

    p {
      font-size: 12px;
      color: #606266;
    }
  }
}
</style>
